// EvidenceTrail — the inspectable trail behind the executive recommendation. Reuses
// EvidencePanel (labelled view-model sort) and adds the REAL claims embedded in the
// outcome plus any linked evaluation metrics. Everything here is a real field; empty
// sections say so rather than inventing content.
import React from "react";
import EvidencePanel from "../panels/EvidencePanel";

export default function EvidenceTrail({ evidence, claims, evaluations }) {
  const claimList = Array.isArray(claims) ? claims : [];
  const evalList = Array.isArray(evaluations) ? evaluations : [];

  return (
    <div data-testid="evidence-trail" className="space-y-3">
      <EvidencePanel evidence={evidence} />

      <div className="rounded-lg border border-slate-800 bg-slate-900/60 p-4">
        <h4 className="mb-2 text-sm font-semibold text-slate-200">Claims</h4>
        {claimList.length === 0 ? (
          <p className="text-xs text-slate-500" data-testid="claims-empty">No claims recorded on this outcome.</p>
        ) : (
          <ul className="space-y-1.5" data-testid="claims-list">
            {claimList.map((c, i) => (
              <li key={c.claim_id || i} className="rounded-md bg-slate-800/40 p-2 text-xs" data-testid="claim-row">
                <div className="flex justify-between gap-2">
                  <span className="text-slate-300">{c.claim_type || "claim"}</span>
                  <span className="text-[10px] text-slate-500">{c.origin || ""}</span>
                </div>
                {c.statement ? <p className="mt-0.5 text-slate-400">{c.statement}</p> : null}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="rounded-lg border border-slate-800 bg-slate-900/60 p-4">
        <h4 className="mb-2 text-sm font-semibold text-slate-200">Evaluations</h4>
        {evalList.length === 0 ? (
          <p className="text-xs text-slate-500" data-testid="evaluations-empty">No linked evaluations.</p>
        ) : (
          <ul className="space-y-1.5" data-testid="evaluations-list">
            {evalList.map((e, i) => {
              const cpa = e.diagnostics && e.diagnostics.cross_producer_agreement;
              return (
                <li key={e.cohort_key || e.evaluation_id || i} className="rounded-md bg-slate-800/40 p-2 text-xs" data-testid="evaluation-row">
                  <div className="flex justify-between gap-2">
                    <span className="text-slate-300">{e.cohort_key || "evaluation"}</span>
                    <span className="text-slate-400">
                      {e.metrics && e.metrics.accuracy != null ? `acc ${e.metrics.accuracy}` : ""}
                    </span>
                  </div>
                  {cpa ? (
                    <p className="mt-0.5 text-[10px] text-slate-500">
                      agreement {cpa.agreements}/{cpa.pairs_compared}
                      {cpa.disagreements > 0 ? ` · ${cpa.disagreements} disagreement(s)` : ""}
                    </p>
                  ) : null}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
